module.exports = __webpack_public_path__ + "static/media/img-mobile-recommendation@3x.b707d17c.png";